import { render, staticRenderFns } from "./ComplementaryCompactCard.vue?vue&type=template&id=de9812aa&scoped=true&"
import script from "./ComplementaryCompactCard.vue?vue&type=script&lang=js&"
export * from "./ComplementaryCompactCard.vue?vue&type=script&lang=js&"
import style0 from "./ComplementaryCompactCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ComplementaryCompactCard.vue?vue&type=style&index=1&id=de9812aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9812aa",
  null
  
)

export default component.exports